import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 1.2rem;
`;

export const Link = styled.span`
  text-decoration: underline;
  display: block;
  cursor: pointer;
`;

export const Message = styled.span`
  font-style: italic;
  color: #f44336;

  &:before {
    content: '"';
  }

  &:after {
    content: '"';
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
